import React from "react";
import "./Privacy.css";
import {Helmet} from "react-helmet";
const Policy = () => {
  return (
    <div className="policy-container">
      <Helmet>
                <meta charSet="utf-8" />
                <title>Privacy Policy - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
      <h1 className="policy-title">Privacy Policy</h1>
      <p className="policy-text">
        Otter Tutors respects your privacy and ensures that any personal data collected during registration and tutoring services will be handled as per our privacy policy. No personal information will be shared with third parties without consent.
      </p>

      <h1 className="policy-title">Cancellation and Refund Policy</h1>
      <p className="policy-text">
        Cancellation of services is not applicable. Refund of the batch amount is not applicable.
      </p>

      <h1 className="policy-title">Intellectual Property</h1>
      <p className="policy-text">
        All content provided by Otter Tutors, including study materials, videos, and online resources, is the intellectual property of Otter Tutors and cannot be reproduced or distributed without explicit permission.
      </p>

      <h1 className="policy-title">Contact Information</h1>
      <p className="policy-text">
        For any questions regarding these terms, please contact us at:
      </p>
      <ul className="contact-info">
        <li>Email: <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
        <li>Phone: +91-9509937969</li>
        <li>Website: <a href="http://www.ottertutors.com" target="_blank" rel="noopener noreferrer">www.ottertutors.com</a></li>
      </ul>
    </div>
  );
};

export default Policy;
